'use client';
import styled from 'styled-components';

export const StyledDropdownGroup = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing(4)};
  width: 100%;
`;
